<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
      <form class="search-box position-relative" @submit.prevent="rechercher">
          
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un produit"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>

        <div class="card-buttons d-sm-flex align-items-center">
          <a href="javascript:void(0);" @click="getAll('produits')"
              class="card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5" 
              :class="{'active': stockName === 'produits'}"> 
              Produit 
          </a>
          <a href="javascript:void(0);" @click="getAll('produitConditionnements')"
              class="card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5 ms-5"
              :class="{'active': stockName === 'produitConditionnements'}"> 
              Produit Conditionnement 
          </a>
          <a href="javascript:void(0);" @click="getAll('produitCondMags')"
              class="card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5 ms-5"
              :class="{'active': stockName === 'produitCondMags'}"> 
              Produit Magasin 
          </a>
        </div>
        <div class="d-sm-flex align-items-center">
          <!-- <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1  bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            :class="{'bg-success': stockName === 'produits'}"
            href="javascript:;"
            @click="getAll('produits')"
          >
            Produit
          </a>
          <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            :class="{'bg-success': stockName === 'produitConditionnements'}"
            href="javascript:;"
            @click="getAll('produitConditionnements')"
          >
            Produit Conditionnement
          </a>
          <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            href="javascript:;"
            @click="getAll('produitCondMags')"
          >
            Produit Magasin
          </a> -->

          <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            href="javascript:;"
            @click="getFiche()"
          >
            Fiche de stock
          </a>
          
          <!-- <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button> -->
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  code
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  libelle
                </th>
                <th v-if="stockName=='produitConditionnements'"
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Qte Conditionnement
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  stock
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(pro, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ pro.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  <span v-if="pro.code">{{ pro.code }}</span>
                  <span v-if="pro?.produit">{{ pro.produit.code }}</span>
                  <span v-if="pro?.produitConditionnement?.produit">{{ pro.produitConditionnement.produit.code }}</span>
                 
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  <span v-if="pro.libelle">{{ pro.libelle }}</span>
                  <span v-if="pro?.nomComplet">{{ pro.nomComplet }}</span>
                  <span v-if="pro?.produitConditionnement">{{ pro.produitConditionnement.nomComplet }}</span>
                </td>
                <td v-if="stockName=='produitConditionnements'" class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ pro.qteCond  }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ pro.qteStock  }}
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <!-- <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#AddElementModal"
                        @click="modification(pro)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" @click="suppression(pro.id,elements,'produit','ce produit')"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1" 
                        ></i>
                        Supprimer
                      </a>
                    </li> -->
                  </ul>
              </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>

  </template>
  
<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { paginationFields } from '../Utilities/paginationFields';
import { error, suppression, openNewWindow } from '../../utils/utils';
import ApiService from "../../services/ApiService";
import  { Produit }  from '../../models/Produit';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import Swal from 'sweetalert2';
import axios from 'axios';

  export default defineComponent({
    name: "ListeProduit",
    components: {
      PaginationComponent
    },
    setup: () => {

      const elements = ref<Array<any>>([])
      const selectedItem = ref(0);
      const element = ref<any>();
      const stockName = ref('produits');
     
      function modification(item) {
        element.value = item;
        selectedItem.value = item.id;
      }

      // BEGIN PAGINATE
      const searchTerm = ref('');
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);

      const handlePaginate = ({ page_, limit_ }) => {
        try {
          page.value = page_;
          getAll(stockName.value,page_, limit_);
        } catch (error) {
          //
          
        }
      };
      function rechercher(){
        getAll(stockName.value, page.value, limit.value, searchTerm.value );
      }
      // END PAGINATE

      const recharger = () => {
        getAll('produits');
      };

      const getFiche = () => {
        return axios.get(`/ficheDeStock`)
        .then(({ data }) => {
          console.log('result', data);

          const maFonction = async () => {
              const result = await Swal.fire({
                html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                icon: "success",
                buttonsStyling: true,
                confirmButtonText: "Aperçu",
                showCancelButton: false,
                cancelButtonText: `Fermer`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-warning",
                },
              });

              if (result.isConfirmed) {
                openNewWindow(data.data, "Fiche");
              }
            };
            setTimeout(maFonction, 300);
        })
        .catch(({ response }) => {
          error(response.data)
        });
      };

      onMounted(() => {
        getAll('produits');
      })

      function getAll(name ='', page = 1, limi = 10, searchTerm = '' ) {
        console.log("le nom", name);
        stockName.value = name;
        
        return ApiService.get(`/${name}?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log('result', data.data.data);
          elements.value = data.data.data;
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          error(response.data)
        });
        
      } 

      return { 
        getAll,
        suppression,
        modification,
        elements,
        recharger,
        selectedItem,
        stockName,

        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher,
        getFiche
      };
    }

  });
  
</script>